/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description Zustand store for Payers
 */
import _ from 'lodash';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { useShallow } from 'zustand/react/shallow';
import { DEFAULT_PAGINATION } from '@veritable/common/constants';

const initialState: Payers.IValues = {
	filterParams: {},
	pageSize: DEFAULT_PAGINATION.pageSize,
	pageNumber: DEFAULT_PAGINATION.pageNumber,
	enrollmentPageSize: DEFAULT_PAGINATION.pageSize,
	enrollmentPageNumber: DEFAULT_PAGINATION.pageNumber,
	enrollmentFilterParams: {},
	enrollmentAppliedParams: {} as Payers.IEnrollmentAppliedParams,
	remountTriggerKey: 0,
};

const usePayerStore = create<Payers.IStore>()(
	devtools(
		(set) => ({
			...initialState,
			actions: {
				setFilterParams: (filterParams: Payers.IFilterParams) => set({ filterParams }),
				setPageSize: (pageSize) => set({ pageSize }),
				setPageNumber: (pageNumber) => set({ pageNumber }),
				setEnrollmentPageSize: (enrollmentPageSize) => set({ enrollmentPageSize }),
				setEnrollmentPageNumber: (enrollmentPageNumber) => set({ enrollmentPageNumber }),
				setEnrollmentFilterParams: (enrollmentFilterParams) => set({ enrollmentFilterParams }),
				setEnrollmentAppliedParams: (enrollmentAppliedParams) =>
					set({ enrollmentAppliedParams, enrollmentPageNumber: DEFAULT_PAGINATION.pageNumber }),
				updateRemountTriggerKey: () => set((state) => ({ remountTriggerKey: state.remountTriggerKey + 1 })),
				reset: () => set({ ...initialState }),
			},
		}),
		{ name: 'Payers' },
	),
);

// Helper hooks to return actions and values separately
const usePayerStoreValues = (): Payers.IValues => usePayerStore(useShallow((state) => _.omit(state, ['actions'])));

const usePayerStoreActions = (): Payers.IActions => usePayerStore(useShallow((state) => state.actions));

export { usePayerStoreValues, usePayerStoreActions };
export default usePayerStore;
